export default __webpack_public_path__ + "static/media/ecoturismo.92ba1b59.png";